<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>{{creditor.Name}} - Credit Records</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-btn color="primary" small text to="/list/report/creditors">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>

        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12">
            <span>Total Credit: {{totalCreditValue}}</span>
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="creditRecords"
              :search="search"
            >
              <!-- template -->
              <template v-slot:item.id="{ item }">
                <v-btn @click="openProductsModal(item.id)" text color="primary">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.Balance="{ item }">{{ item.Balance.toLocaleString() }}</template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn icon :to="`/creditors/${item.id}`">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3" v-show="Balance > 0" style="margin-top: -60px">
            <v-btn text color="accent" @click="openDialog">
              <v-icon left>mdi-credit-card-check-outline</v-icon>Record Credit
              Payment
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- clearing credit dialog -->
    <v-dialog v-model="dialog" max-width="700px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Record Credit Payment</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row class="subtitle-2 text--primary">
              <v-col cols="6">Supplier: {{creditor.Name}}</v-col>
              <v-col cols="6">Current Credit: {{totalCreditValue}}</v-col>
              <v-col cols="6">
                <v-text-field
                  name="creditorPaymentAmount"
                  v-model="amount"
                  label="Amount To Clear"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6">New Balance: {{newBalance}}</v-col>
              <v-col cols="6">
                <v-autocomplete
                  name="creditorPaymentAccount"
                  dense
                  outlined
                  v-model="accountId"
                  :items="accounts"
                  label="Payment Mode"
                  item-text="Name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
              </v-col>
              <v-col cols="12">
                <v-btn color="accent" @click="save" :loading="loader">
                  <v-icon left>mdi-content-save</v-icon>Save
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card>
    </v-dialog>
    <!-- end -->

    <!-- products modal -->
    <v-dialog v-model="productsDialog" max-width="800px">
      <v-card>
        <v-toolbar dense color="accent" dark>
          <v-toolbar-title>Purchased Products</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="productsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid class="subtitle-2 text--primary">
            <v-row dense id="po">
              <v-col cols="12" xs="12" md="3">
                <span>Customer: {{ record.ocrd && record.ocrd.Name}}</span>
              </v-col>

              <v-col cols="12" xs="12" md="3">Receipt No: {{record.DocNum}}</v-col>

              <v-col cols="12" xs="12" md="3">Date: {{record.DocDate}}</v-col>

              <v-col cols="12" id="docForm">
                <v-data-table
                  light
                  :items-per-page="pageItems"
                  :headers="purchasedHeaders"
                  :items="purchasedItems"
                  item-key="id"
                  hide-default-footer
                  disable-sort
                  :mobile-breakpoint="zeroValue"
                >
                  <template v-slot:item.Name="{ item }">{{item.Name}}</template>

                  <template v-slot:item.Quantity="{ item }">{{item.Quantity}}</template>

                  <template v-slot:item.Price="{ item }">
                    <span v-if="item.Price">{{item.Price.toLocaleString()}}</span>
                  </template>

                  <template v-slot:item.DisplayTotal="{ item }">{{item.DisplayTotal}}</template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of products modal -->
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      creditRecords: [],
      productsDialog: false,
      purchasedItems: [],
      record: {},
      search: "",
      pageItems: 100,
      dialog: false,
      loader: false,
      creditor: {},
      amount: null,
      Balance: null,
      accountId: null,
      accounts: [],
      date: new Date().toISOString().substr(0, 10),
      headers: [
        { text: "Action", value: "id" },
        { text: "Total Sale", value: "DocTotal" },
        { text: "Total Paid", value: "PaidSum" },
        { text: "Balance", value: "Balance" },
        { text: "Date", value: "DocDate" },
      ],
      purchasedHeaders: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "DisplayTotal" },
      ],
    };
  },
  computed: {
    totalCreditValue() {
      let total = 0;
      if (this.Balance) {
        total = this.Balance.toLocaleString();
      }
      return total;
    },
    newBalance() {
      let amountPaid;
      let newBalance;
      if (this.amount) {
        amountPaid = parseFloat(this.amount);
        newBalance = this.Balance - amountPaid;
      } else {
        amountPaid = 0;
        newBalance = this.Balance - amountPaid;
      }
      return newBalance.toLocaleString();
    },
  },
  watch: {
    "$route.params.id": {
      handler: "getRecords",
      immediate: true,
    },
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    setDate(date) {
      this.date = date;
    },
    save() {
      const self = this;
      const data = {
        CardCode: self.creditor.id,
        DocDate: self.date,
        o_a_c_t_s_id: self.accountId,
        SumApplied: self.amount,
      };
      if (this.accountId == null || this.amount == null) {
        this.$refs.snackbar.show("Account or amount missing!", "red");
      } else {
        const url = "/outgoing-payments";
        self.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.loader = false;
              location.reload();
            } else {
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    openProductsModal(val) {
      const self = this;
      this.$store.commit("loader", true);
      self.record = {};
      this.$store
        .dispatch("get", `/documents/12/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.record = res.ResponseData;
            const products = [];
            if (res.ResponseData.rows) {
              for (const row of res.ResponseData.rows) {
                row.Name = row.product.Name;
                row.DisplayTotal = row.LineTotal.toLocaleString();
                products.push(row);
              }
              self.purchasedItems = products;
              self.productsDialog = true;
              this.$store.commit("loader", false);
            }
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRecords(val) {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.creditRecords = res.ResponseData.openGoodReceipts;
            self.Balance = res.ResponseData.Balance;
            self.creditor = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getAccounts();
  },
};
</script>

<style lang="scss" scoped>
</style>